import script from "./Period.vue?vue&type=script&setup=true&lang=js"
export * from "./Period.vue?vue&type=script&setup=true&lang=js"

import "./Period.vue?vue&type=style&index=0&id=3415951c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3415951c"]])

export default __exports__